import { useEffect, useRef } from 'preact/hooks';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { tourSteps } from '../lib/tour-steps';

export function OnboardingTour({ isOpen, onComplete, onSkip }) {
  const tourRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      // Clean up any existing tour
      if (tourRef.current) {
        tourRef.current.cancel();
        tourRef.current = null;
      }
      return;
    }

    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: 'unplug-tour-step',
          scrollTo: { behavior: 'smooth', block: 'center' },
          cancelIcon: { enabled: true },
          modalOverlayOpeningPadding: 8,
          modalOverlayOpeningRadius: 8
        }
      });

      // Add steps with proper button configurations
      tourSteps.forEach(step => {
        tour.addStep({
          ...step,
          buttons: step.buttons.map(btn => ({
            text: btn.text,
            action: btn.action,
            classes: btn.secondary ? 'shepherd-button-secondary' : 'shepherd-button-primary'
          }))
        });
      });

      tour.on('complete', () => {
        tourRef.current = null;
        onComplete();
      });

      tour.on('cancel', () => {
        tourRef.current = null;
        onSkip();
      });

      tour.start();
      tourRef.current = tour;
    }, 300);

    return () => {
      clearTimeout(timer);
      if (tourRef.current) {
        tourRef.current.cancel();
        tourRef.current = null;
      }
    };
  }, [isOpen, onComplete, onSkip]);

  return null; // Shepherd manages its own DOM
}
